(function ($) {

    $(document).ready(function () {
        bindButtons();
    });

    var cta_details_outer = $('.expandable_cta_content');
    var cta_details_outer_items = $('.expandable_cta_content .inner > div');

    /**
     * TODO Move this to the THEME
     * @param selector
     */
    function toggle_cta_detail(selector) {
        var scroll_offset_holder = $('.bookable_scroll_offset');
        var cta_details_outer_wrap = cta_details_outer.find('.wrap');

        if (scroll_offset_holder.length) {
            var hh = $('#header').height();
            var holderTop = scroll_offset_holder.offset().top;
            var scrollOffset = holderTop - hh;
            $('html,body').stop().animate({scrollTop: scrollOffset}, 500);
        }

        cta_details_outer.addClass('closed');
        cta_details_outer_items.hide();
        var current = $(selector);
        current.css('opacity', 0).show();
        current.css('opacity', 1);
        cta_details_outer.height(cta_details_outer_wrap.outerHeight(true));
        cta_details_outer.removeClass('closed');
    }

    function bindButtons() {
        $(document).on('click', '[data-bookable_type]', function (e) {
            var button = $(this);
            var cfg = button.data();
            if (cfg.expand_id) {
                toggle_cta_detail(cfg.expand_id);
            }
            if(cfg.property_id) {
                var property_id = cfg.property_id;
            }
            if (cfg.bookable_type == 'booking_engine') {
                var bookParams = {};
                if (typeof cfg.offer_tk !== 'undefined' && cfg.offer_tk != '') {
                    bookParams.promoCode = cfg.offer_tk;
                }
                var checkin_date = new Date();
                var checkout_date = new Date(checkin_date.getTime() + 86400000);

                if (typeof cfg.offer_checkin !== 'undefined' && cfg.offer_checkin != '') {
                    var onlyNumberRE = /^\+([0-9]+)$/;
                    var dateAndNumberRE =/^(([0-9]{2})\/([0-9]{2})\/([0-9]{4}))(\s+(\+([0-9]+)))?$/;
                    var todayTimestamp = (new Date()).getTime();
                    if (onlyNumberRE.test(cfg.offer_checkin)) {
                        var results = cfg.offer_checkin.match(onlyNumberRE);
                        var days = parseInt(results[1], 10);
                        if (isNaN(days) || days < 0) {
                            days = 0;
                        }
                        checkin_date = new Date(todayTimestamp + (days * 86400000));
                    } else if (dateAndNumberRE.test(cfg.offer_checkin)) {
                        var results = cfg.offer_checkin.match(dateAndNumberRE);
                        var checkin_delta = 0;
                        var day = parseInt(results[2], 10);
                        var month = parseInt(results[3], 10);
                        var year = parseInt(results[4], 10);

                        var tmp_date = new Date(year, month - 1,  day);
                        if (typeof results[7] !== 'undefined' && results[7] != '') {
                            checkin_delta = parseInt(results[7], 10);
                            if (isNaN(checkin_delta) || checkin_delta < 0) {
                                checkin_delta = 0;
                            }
                        }
                        var today_plus_delta = new Date(todayTimestamp + (checkin_delta * 86400000));

                        // If the date is in the past, just apply the delta to today
                        if (today_plus_delta > tmp_date) {
                            checkin_date = today_plus_delta;
                        } else {
                            checkin_date = tmp_date;
                        }
                    }
                    if (typeof cfg.offer_minstay === 'undefined' || cfg.offer_minstay === '') {
                        cfg.offer_minstay = '1';
                    }
                    if (typeof cfg.offer_minstay !== 'undefined' && cfg.offer_minstay != '') {
                        var checkout_delta = parseInt(cfg.offer_minstay, 10);
                        if (isNaN(checkout_delta) || checkout_delta < 1) {
                            checkout_delta = 1;
                        }
                        checkout_date = new Date(checkin_date.getTime() + (checkout_delta * 86400000) );
                    }
                    bookParams.checkInDate = checkin_date;
                    bookParams.checkOutDate = checkout_date;
                }
                // TODO all the rest
                if(property_id) {
                    bookParams.hotelId = property_id;
                }
                dedgeBookingInstance.getProvider().bookNow(bookParams);
            }
        });
        var all_inner_elements = cta_details_outer.find('.inner > div');
        cta_details_outer.find('.close').click(function () {
            cta_details_outer.height(0);
            all_inner_elements.hide().css('opacity', 0);
        });
    }
})(jQuery);